export const NotFoundPage = () => {
    return <div>NotFoundPage</div>;
};
